export { Testimonial } from "./Testimonial";
export type { TestimonialProps } from "./Testimonial";
